import { render, staticRenderFns } from "./printingSettings.vue?vue&type=template&id=a6a51b6a"
import script from "./printingSettings.vue?vue&type=script&lang=js"
export * from "./printingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports